//import card_background from "../card_background.png";

interface ThankYouNoteProps {
  style?: React.CSSProperties;
}

export default function ThankYouNote({ style }: ThankYouNoteProps) {
  return (
    <section>
    </section>
    /*
    <section style={style}>
      <div 
        className="planning-card"
        style={{
          backgroundImage: `url(${card_background})`,
          backgroundPosition: "120% 28%",
          backgroundSize: "200%",
          backgroundRepeat: "no-repeat",
          textAlign: "center",
          minHeight: "auto",
          padding: "40px 32px",
        }}
      >
        <div className="planning-card-header" style={{ justifyContent: "center" }}>
          <h2 className="title" style={{ fontSize: "28px", fontWeight: 700, marginBottom: "24px" }}>
            It's a wrap!
          </h2>
        </div>
        <p style={{ fontSize: "16px", lineHeight: "1.7", textAlign: "center" }}>
          Our HackEvents 2025 are in the books. We thank the over 400 participants for attending the events in Geneva, Lugano, Zurich and Luxembourg as well as our Sponsors Vectra, Tenable, Splunk, OneIdentity, Kaspersky, KnowBe4, C2SEC, Cribl, Menlo, Airlock and Microsoft for their support. Come join us in 2026!
        </p>
      </div>
    </section>
    */
  );
}